import { render, staticRenderFns } from "./store_detail.vue?vue&type=template&id=f784a8f0&scoped=true&"
import script from "./store_detail.vue?vue&type=script&lang=js&"
export * from "./store_detail.vue?vue&type=script&lang=js&"
import style0 from "./store_detail.vue?vue&type=style&index=0&id=f784a8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f784a8f0",
  null
  
)

export default component.exports